module.exports = __webpack_public_path__ + "img/yoanna.e82511da.png";